import { actions as allActions } from '../reducers';

export const types = {
  ON_INITIALIZE_APPLICATION_FULFILLED: 'ON_INITIALIZE_APPLICATION_FULFILLED',
  ON_INITIALIZE_APPLICATION_PENDING: 'ON_INITIALIZE_APPLICATION_PENDING',
  ON_INITIALIZE_APPLICATION_REJECT: 'ON_INITIALIZE_APPLICATION_REJECT'
};
export const onInitializeApplicationFulfilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_INITIALIZE_APPLICATION_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

export const onInitializeApplicationRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_INITIALIZE_APPLICATION_REJECT
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onInitializeApplication = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_INITIALIZE_APPLICATION_PENDING
  });

  const {
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return dispatch(allActions.onInitializeCache())
    .then(() =>
      dispatch(
        onInitializeApplicationFulfilled({
          fulfillCallback,
          message: fulfillMessage || 'success'
        })
      )
    )
    .catch(() =>
      dispatch(
        onInitializeApplicationRejected({
          rejectCallback,
          message: rejectMessage || 'failed'
        })
      )
    );
};


// WEBPACK FOOTER //
// ./src/actions/application.js